import React from 'react';
import PropTypes from 'prop-types';
import ApplicationInfo from './ApplicationInfo/ApplicationInfo';
import style from '../../../styles/styles';
import ModuleService from '../../../services/module';
import OpenExploreModuleBlock from './ModuleBlock/OpenExploreModuleBlock/OpenExploreModuleBlock';
import UserModuleBlock from './ModuleBlock/UserModuleBlock/UserModuleBlock';
import CommentModuleBlock from './ModuleBlock/CommentModuleBlock/CommentModuleBlock';
import PushModuleBlock from './ModuleBlock/PushModuleBlock/PushModuleBlock';
import withTranslation from '../../../hoc/withTranslation';
import ReportModuleBlock from './ModuleBlock/ReportModuleBlock/ReportModuleBlock';
import NewsModuleBlock from './ModuleBlock/NewsModuleBlock/NewsModuleBlock';
import PageModuleBlock from './ModuleBlock/PageModuleBlock/PageModuleBlock';
import FirebaseModuleBlock from './ModuleBlock/FirebaseModuleBlock/FirebaseModuleBlock';
import DynamicLinkModuleBlock from './ModuleBlock/DynamicLinkModuleBlock/DynamicLinkModuleBlock';
import RoadBookModuleBlock from './ModuleBlock/RoadBookModuleBlock/RoadBookModuleBlock';
import GamificationModuleBlock from './ModuleBlock/GamificationModuleBlock/GamificationModuleBlock';
import QuizModuleBlock from './ModuleBlock/QuizModuleBlock/QuizModuleBlock';
import AdminBoard from '../../admin/AdminBoard/AdminBoard';
import AccessTokenModuleBlock from './ModuleBlock/AccessTokenModuleBlock/AccessTokenModuleBlock';
import KeycloakModuleBlock from './ModuleBlock/KeycloakModuleBlock/KeycloakModuleBlock';

class ApplicationFull extends React.Component {

    static propTypes = {
        app: PropTypes.object.isRequired,
        postPicture: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
        handleRemoveAdmin: PropTypes.func,
    };

    render() {

        return (
            <div>
                <div className="row">
                    <div style={style.leftContainer} className="col-xs-12 col-lg-4">
                        <ApplicationInfo
                            app={this.props.app}
                            postPicture={this.props.postPicture}
                        />
                        <AdminBoard
                            admins={this.props.app.admins}
                            user={this.props.user}
                            handleDeleteAdmin={this.props.handleRemoveAdmin}
                            loading={this.props.app.adminsLoading}
                        />
                    </div>
                    <div style={style.col} className="col-xs-12 col-lg-8">
                        <div className="row">
                            {ModuleService.hasModule(this.props.app, ModuleService.OPEN_EXPLORE) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <OpenExploreModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.ROAD_BOOK) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <RoadBookModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.USER) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <UserModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.KEYCLOAK) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <KeycloakModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.COMMENTS) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <CommentModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.PUSH) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <PushModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.REPORT) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <ReportModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.NEWS) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <NewsModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.PAGE) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <PageModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.GAMIFICATION) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <GamificationModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.QUIZ) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <QuizModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.FIREBASE) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <FirebaseModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.DYNAMIC_LINK) &&
                                <div style={style.col} className="col-xs-12 col-lg-6">
                                    <DynamicLinkModuleBlock app={this.props.app} />
                                </div>
                            }
                            {ModuleService.hasModule(this.props.app, ModuleService.ACCESS_TOKEN)
                                && (
                                    <div style={style.col} className="col-xs-12 col-lg-6">
                                        <AccessTokenModuleBlock app={this.props.app} />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation(ApplicationFull);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ApplicationFull.js